
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from 'framer-motion';
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Learn from "./pages/Learn";
import Practice from "./pages/Practice";
import Progress from "./pages/Progress";
import Workout from "./pages/Workout";
import LearningPaths from "./pages/LearningPaths";
import LearningPathDetail from "./pages/LearningPathDetail";
import ModuleContent from "./pages/ModuleContent";
import AdminModules from "./pages/admin/AdminModules";
import AdminModuleEdit from "./pages/admin/AdminModuleEdit";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/learn" 
                element={
                  <ProtectedRoute>
                    <Learn />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/learning-paths" 
                element={
                  <ProtectedRoute>
                    <LearningPaths />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/learning-paths/:pathId" 
                element={
                  <ProtectedRoute>
                    <LearningPathDetail />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/module/:moduleId" 
                element={
                  <ProtectedRoute>
                    <ModuleContent />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/practice" 
                element={
                  <ProtectedRoute>
                    <Practice />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/progress" 
                element={
                  <ProtectedRoute>
                    <Progress />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/workout" 
                element={
                  <ProtectedRoute>
                    <Workout />
                  </ProtectedRoute>
                } 
              />
              {/* Admin Routes */}
              <Route 
                path="/admin/modules" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminModules />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/modules/:moduleId" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminModuleEdit />
                  </ProtectedRoute>
                } 
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AnimatePresence>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
